export default "__VITE_ASSET__CENq9_DQ__"